import { createCmsProviderAdapter } from '@eneco/cms-sanity';
import { createSitecoreAdapter } from '@eneco/cms-sitecore';
import env from '@eneco/common/env';
// Deep import, NOT the `@eneco/next/server` barrel. That barrel re-exports the
// Sitecore api proxy and the editing preview, which pull in `got` and the JSS
// editing cache, so importing it here dragged `http2`, `net`, `tls`, `fs` and
// `child_process` into the browser bundle by way of `pages/[[...route]].tsx` and
// 500'd the container. This module imports nothing and only reads `process.env`.
import { getContainerBasePath } from '@eneco/next/server/utils/getContainerBasePath';

import { sanitySite } from './config';

let instance: ReturnType<typeof createSitecoreAdapter> | undefined;

export const getCmsAdapter = () => {
  if (!instance) {
    const layoutServiceUrl = `${env('SITECORE_API_HOST')}${env('SITECORE_LAYOUT_SERVICE_ROUTE')}`;
    const apiKey = env('SITECORE_API_KEY');
    const site = env('SITECORE_API_SITE');
    instance = createSitecoreAdapter({ layoutServiceUrl, apiKey, site });
  }
  return instance;
};

// mkb serves the `?_cms=` override and Sanity draft mode on acceptance/production too, not just
// development/local (see `allowSharedEnvironment` in `is-sanity-enabled.ts`). Needed because the
// Studio previews this site at `https://www.acc.eneco.nl`; without it `isSanityEnabled` closes on
// acceptance, the adapter is never built, and Presentation frames a Sitecore page.
// Sitecore still serves every unforced request — this only widens where the override works.
export const { getSanityAdapter, selectCmsAdapter } = createCmsProviderAdapter(getCmsAdapter, {
  site: sanitySite,
  allowSharedEnvironment: true,
  // `/mkb`. `getSSP` prepends it because Sitecore's `item=` lookup wants the
  // full item path; Sanity slugs carry no container prefix, so it has to come
  // back off before slug resolution. Same source `getSSP` uses, so they cannot
  // drift apart.
  basePath: getContainerBasePath(),
});
